/**
 * 保留小数点 keepDecimal，自动补0
 * @param value
 * @param len
 * @returns
 */
export function keepDecimal(value: string, len: number): string {
  let tmpValue: string | number = Math.round(parseFloat(value) * 100) / 100;
  const xsd = tmpValue.toString().split('.');
  if (xsd.length === 1) {
    tmpValue = `${tmpValue.toString()}.${new Array(len).fill(0)
      .join('')}`;
    return tmpValue;
  }
  if (xsd.length > 1) {
    tmpValue = tmpValue.toString() + new Array(len - xsd[1].length).fill(0)
      .join('');
    return tmpValue;
  }
  return '';
}

/**
 * 格式化数字，千位分隔符
 * @param value
 * @param digit 保留小数
 * @returns
 */
export function thousandSplit(value?: string, digit?: number): string {
  if (!value || isNaN(+value)) {
    return value as string;
  }

  const tmpValue = digit ? keepDecimal(`${value}`, digit) : value;

  return tmpValue
    ? tmpValue.toString().replace(/^(\d+)((\.\d+)?)$/, (_v1, v2, v3) => v2.replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,') + v3)
    : tmpValue;
}
